{
  "lib_calendar": {
    "appointment-cancellation-dialog": {
      "buttons": {
        "back": "Back",
        "cancel": "Cancel appointment",
        "close": "Close",
        "next": "Next"
      },
      "text": {
        "title": "Appointment cancellation",
        "description": "Can you tell us more, why you cannot keep the appointment anymore?",
        "appointment-cancelled-successfully": "The appointment was successfully canceled!",
        "block_customer": "Would you like to block this customer?",
        "message_to_customer": "Message to customer",
        "no": "NO",
        "no_show": "Customer has not appeared",
        "not_show_up": "This customer has already failed to show up for {{ total }} appointment(s) in the past.",
        "not_show_up_first_time": "This is the first time that this customer has not appeared.",
        "reason": "Your reason",
        "reason-better-deal": "I have found a better deal",
        "reason-mistake": "I have changed my mind or booked by mistake",
        "reason-other": "Other reason",
        "reason-salon-asked-to-cancel": "The salon has asked if I can cancel the appointment",
        "reason-unforeseen-circumstance": "Because of unforeseen circumstances, I could not keep the appointment",
        "yes": "YES"
      }
    },
    "appointment-chat-box": {
      "text": {
        "chat-with": "Chat with {{name}}",
        "customer": "customer",
        "message": "Your message",
        "salon": "salon"
      }
    },
    "appointment-confirmation-dialog": {
      "buttons": {
        "cancel": "Cancel",
        "confirm-and-book": "Confirm and book",
        "confirm-and-update": "Confirm and update"
      },
      "text": {
        "title": "Appointment confirmation",
        "book-successfully": "Your appointment was successfully booked",
        "update-successfully": "Your appointment was successfully updated"
      }
    },
    "appointment-details": {
      "text": {
        "serve-by-staff": "Serve by {{staff}}",
        "staff_selected_by_customer": "Staff is selected by customer",
        "total": "Total"
      }
    },
    "appointment-details-card": {
      "buttons": {
        "checkin": "CHECK IN"
      },
      "text": {
        "appointment-canceled-by-salon": "Appointment was cancelled by salon",
        "appointment-canceled-by-you": "Appointment was cancelled by you",
        "status": "Status"
      }
    },
    "appointment-details-dialog": {
      "buttons": {
        "back": "Back",
        "edit": "Edit appointment"
      },
      "text": {
        "appointment_history": "Appointment history",
        "edit_profile": "Edit profile",
        "more_about_customer": "More about this customer",
        "Visit history": "Visit history"
      }
    },
    "appointment-details-page": {
      "buttons": {
        "cancel": "Cancel appointment"
      },
      "text": {
        "creation_time": "Creation time",
        "last_update": "Last update"
      }
    },
    "appointment-form": {
      "text": {
        "customer-selection": "Customer selection",
        "note": "Note",
        "rwg_appointment_hint": "Google appointment service is not editable",
        "service-selection": "Service selection",
        "staff-cannot-serve-any-hint": "Selected staff cannot serve any selected service. Please consider to choose another staff!",
        "staff-cannot-serve-all-hint": "Selected staff cannot serve all selected services. Some of them will be served by another staff!",
        "staff_selected_by_customer": "Staff is selected by customer",
        "staff-selection": "Staff selection"
      }
    },
    "appointment-form-dialog": {
      "text": {
        "create_new_appointment": "Book new appointment",
        "edit_appointment": "Change appointment"
      },
      "buttons": {
        "book": "BOOK",
        "close": "Close",
        "save": "Save"
      }
    },
    "appointment-history-dialog": {
      "text": {
        "appointment_history": "Currently seen appointments",
        "empty_history": "Appointment view history is empty",
        "last_seen": "Last seen"
      }
    },
    "appointment-table": {
      "buttons": {
        "view": "View"
      },
      "text": {
        "all": "All",
        "customer": "Customer",
        "date": "Date",
        "service": "Service",
        "staff": "Staff",
        "status": "Status"
      }
    },
    "available-date-selection-by-month": {
      "text": {
        "not-available": "Not available. Please select another month!"
      }
    },
    "available-date-selection-by-serie": {
      "text": {
        "date_range": "Date range",
        "end_time": "End time",
        "from_date": "Start date",
        "start_time": "Start time",
        "to_date": "End date",
        "repeated_week_day": "Repeat on weekdays",
        "repeated_week_day_required": "Please select at least one weekday"
      }
    },
    "available-date-selection-form": {
      "text": {
        "date_selection": "Date selection",
        "repeat_settings": "Repeat settings",
        "unable_to_block": "Nothing will be blocked, because salon is closed or there are already other appointments/blockers on selected days"
      }
    },
    "available-slot-selection-by-date": {
      "text": {
        "afternoon": "AFTERNOON",
        "evening": "EVENING",
        "morning": "MORNING",
        "not-available": "Not available. Please select another date!"
      }
    },
    "available-slot-selection-by-week": {
      "text": {
        "not-available": "Not available. Please select another week!"
      }
    },
    "available-slot-selection-form": {
      "buttons": {
        "date-view": "Date view",
        "week-view": "Week view"
      },
      "text": {
        "date-time-selection": "Date time selection",
        "date-time-selection-hint": "Please select at least one service",
        "slot_tact": "Booking time interval",
        "slot_tact_example": {
          "5": "e.g. 09:00, 09:05, 09:10, 09:15, 09:20, etc.",
          "15": "e.g. 09:00, 09:15, 09:30, 09:45, 10:00, etc.",
          "30": "e.g. 09:00, 09:30, 10:00, 10:30, 11:00, etc.",
          "60": "e.g. 09:00, 10:00, 11:00, 12:00, 13:00, etc."
        }
      }
    },
    "blocker-deletion-dialog": {
      "buttons": {
        "delete": "Delete"
      },
      "text": {
        "title": "Blocker deletion",
        "delete_confirmation": "Are you sure to delete this blocker? This action cannot be undone.",
        "delete_single_blocker_in_series": "Delete only this blocker",
        "delete_series_blocker": "Delete all blockers in this series",
        "delete_successfully": "Deleted successfully"
      }
    },
    "blocker-details-card": {
      "text": {
        "belong_to_series_blocker": "This blocker is an element of a series blocker"
      }
    },
    "blocker-details-dialog": {
      "text": {
        "creation_time": "Creation time",
        "last_update": "Last update"
      },
      "buttons": {
        "back": "Back",
        "edit": "Edit blocker",
        "delete": "Delete blocker"
      }
    },
    "blocker-form": {
      "text": {
        "all_day": "Block for the whole day",
        "duration": "Duration",
        "off": "OFF",
        "on": "ON",
        "reason": "Description",
        "reason_placeholder": "e.g. reason for blocker",
        "series_blocker": "Series blocker",
        "staff-selection": "Staff selection"
      }
    },
    "blocker-form-dialog": {
      "text": {
        "blocker_updated": "Blocker is updated successfully",
        "create_new_blocker": "Create new blocker",
        "edit_blocker": "Change blocker",
        "new_blocker_created": "New blocker is created successfully",
        "new_serie_blocker_created": "New series blocker is created successfully"
      },
      "buttons": {
        "close": "Close",
        "create": "Create",
        "save": "Save"
      }
    },
    "business-notification-dialog": {
      "buttons": {
        "close": "Close"
      },
      "text": {
        "no_notification": "No notifications since last {{ day }} days",
        "notification": "Notifications",
        "staff": "Staff"
      }
    },
    "date-picker": {
      "current": {
        "agenda": "This week",
        "day": "Today",
        "month": "This month",
        "week": "This week"
      }
    },
    "floating-buttons": {
      "buttons": {
        "new_appointment": "New appointment",
        "new_blocker": "New blocker"
      }
    },
    "quick-update-appointment-dialog": {
      "buttons": {
        "cancel": "Cancel",
        "confirm": "Confirm"
      },
      "text": {
        "original_appointment": "Original appointment",
        "original_blocker": "Original blocker",
        "staff": "Staff",
        "start_time": "Date and time",
        "update_unavailable": "The desired time slot is unavailable!",
        "updated_confirmation": "Update confirmation",
        "updated_successfully": "Updated successfully!"
      }
    },
    "tool_bar": {
      "buttons": {
        "more": "More",
        "view_appointment_history": "Currently seen appointments",
        "view_cancelled_appointment": "Show cancelled appointments"
      },
      "view_mode": {
        "agenda": "Agenda view",
        "day": "Day view",
        "month": "Month view",
        "week": "Week view"
      }
    }
  }
}
